export default "__VITE_ASSET__5691c52d__"